"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxAttemptsError = void 0;
const types_1 = require("./types");
class MaxAttemptsError extends Error {
    constructor(attempts, ...params) {
        super(...params);
        this.type = types_1.ERetryPolicyError.MAX_ATTEMPTS;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MaxAttemptsError);
        }
        this.attempts = attempts;
        this.message = `Maximum attempts exceeded: ${this.attempts}`;
    }
}
exports.MaxAttemptsError = MaxAttemptsError;
//# sourceMappingURL=MaxAttemptsError.js.map